@if (showToggleAllocation) {
<div>
  <button type="button" class="btn btn-primary btn-lg"
    (click)="toggleAllocationModule()">Allocate to this module</button>
</div>
} @else {
<div>
  <div class="well-header">
    <span class="header-lable-sm">Wells: </span><span>{{ totalMappedWells }}</span>
    <span class="header-lable-sm">Total Allocation: </span><span>{{ totalAllocationPercentage| percent:'2.2-4' }}</span>
  </div>
  @if (inactiveAssetsMessage) {
  <div class="alert alert-danger" role="alert">
    You have inactive assets allocated to this project, please remove the inactive assets.
  </div>
  }
  <mat-drawer-container class="multi-well-container">
    <mat-drawer #drawer mode="side">
      <div class="well-available-selection">
        <div position="top" class="p-1 k-header k-grid-toolbar">
          <button type="button" kendoButton (click)="drawer.toggle(); addWellToMapping();"
            class="k-button k-primary" [disabled]="disableAddSelected">
            Add Selected
          </button>
          <button type="button" kendoButton (click)="drawer.toggle(); cancelAvailableWellsSelection()"
            class="k-button k-primary">
            Cancel
          </button>
        </div>
        <ag-grid-angular #availablesGrid class="ag-theme-balham content-grid"
          (gridReady)="onAvailablesGridReady($event)"
          [gridOptions]="availablesGridOptions"
          (selectionChanged)="onAvailablesSelectionChanged($event)">
        </ag-grid-angular>
      </div>
    </mat-drawer>
    <mat-drawer-content #content>
      <div class="well-sidenav-content">
        <div position="top" class="p-1 k-header k-grid-toolbar">
          <button type="button" type="button" kendoButton themeColor="primary" [disabled]="!moduleIsEditable"
            (click)="drawer.toggle(); " class="k-button k-primary">
            Add
          </button>
          @if (allocationAllowed) {
          <button type="button" kendoButton themeColor="primary" [disabled]="!moduleIsEditable || disableAllocateEvenly" class='k-button k-primary'
            (click)='splitAllocation();'>
            Allocate Evenly
          </button>
          }
          <button type="button" kendoButton themeColor="primary" (click)="removeMappedWells()"
            [disabled]="disableRemoveMapped" class="k-button k-primary">
            Remove
          </button>
        </div>
        <ag-grid-angular #mappedGrid class="ag-theme-balham content-grid" (gridReady)="onMappedGridReady($event)"
          [gridOptions]="mappedGridOptionsHandler"
          (selectionChanged)="onMappedSelectionChanged($event)"
          (cellValueChanged)="onMappedCellValueChanged($event)">
        </ag-grid-angular>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
}

@if (openedWarning) {
<kendo-dialog title="Please confirm" (close)="onWarningClose()" [minWidth]="250" [width]="450">
  <div>
    <p>These Well(s) are currently assigned to another Tank Battery Asset, do you want to proceed and override the Asset
      Mapping?</p>
  </div>
  <kendo-dialog-actions>
    <button type="button" kendoButton (click)="onWarningClose()">No</button>
    <button type="button" kendoButton (click)="onWarningSave()">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
}